import { Record } from 'immutable';
import { FETCH_SOURCE } from 'constants/storeStates';

export const defaultValues = {
    authenticated: false,
    source: FETCH_SOURCE.INITIAL,
    errorMessage: null,
    loading: false,
};

export default class Session extends Record(defaultValues, Session) {
    constructor(values) {
        super({
            ...values,
        });
    }
}
